import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';

const columns = [
  { id: 'month', label: 'Month', minwidth: 50 },
  { id: 'debtName', label: 'Debt', minWidth: 100 },
  {
    id: 'regularPayment',
    label: 'Regular Payment',
    minWidth: 80,
    format: value => value.toFixed(2)
  },
  {
    id: 'extraPayment',
    label: 'Extra Payment',
    minWidth: 80,
    align: 'right',
    format: value => value.toFixed(2),
  },
  {
    id: 'totalPayment',
    label: "Total Payment",
    minWidth: 80,
    align: 'right',
    format: value => value.toFixed(2)
  },
  {
    id: 'interest',
    label: 'Interest',
    minWidth: 50,
    align: 'right',
    format: value => value.toFixed(2),
  },
  {
    id: 'balance',
    label: 'Balance',
    minWidth: 80,
    align: 'right',
    format: value => value.toFixed(2),
  },
];

const useStyles = makeStyles({
  root: {
    width: '100%',
  },
  tableWrapper: {
    maxHeight: 440,
    overflow: 'auto',
  },
});

export default function PayoffSchedule(props) {

  const classes = useStyles();

  // state
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = event => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  console.log("SCHEDULE")
  console.log(props.schedule)
  return (
    <div>
      <Paper className={classes.root}>
        <div className={classes.tableWrapper}>
          <p>Schedule</p>
          <Table stickyHeader size="small" aria-label="sticky table">
            <TableHead>
              <TableRow>
                {columns.map(column => (
                  <TableCell
                    key={column.id}
                    align={column.align}
                    style={{ minWidth: column.minWidth }}
                  >
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {props.schedule.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => {
                return (
                  <TableRow hover role="checkbox" tabIndex={-1} key={index}>
                    {columns.map(column => {
                      const value = row[column.id];
                      return (
                        <TableCell key={column.id} align={column.align}>
                          {column.format && typeof value === 'number' ? column.format(value) : value}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </div>
        <TablePagination
          rowsPerPageOptions={[10, 25, 100]}
          component="div"
          count={props.schedule.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onChangePage={handleChangePage}
          onChangeRowsPerPage={handleChangeRowsPerPage}
        />
      </Paper>
    </div>
  );
}
